/**
 * @param email An email address in string format
 * @returns Boolean indicating if the string contains a valid email address
 */
export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/

  return emailRegex.test(email)
}
